import React from "react";
import { useLocation } from "react-router-dom";
import { HelpCircle, Lightbulb } from "lucide-react";
import { HELP } from "../config/guide";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "./ui/sheet";

export default function HelpButton() {
  const { pathname } = useLocation();
  const help = HELP[pathname];
  if (!help) return null;

  return (
    <Sheet>
      <SheetTrigger asChild>
        <button
          data-testid="help-button"
          title="Guida di questa pagina"
          className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-primary/30 text-primary hover:bg-primary/10 transition-colors"
        >
          <HelpCircle size={20} />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto" data-testid="help-panel">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 text-left">
            <Lightbulb size={20} className="text-primary" /> {help.title}
          </SheetTitle>
        </SheetHeader>
        {help.audience && (
          <div className="mt-2 inline-block rounded-full bg-secondary px-3 py-1 text-xs font-bold uppercase tracking-wide text-muted-foreground">
            Per: {help.audience}
          </div>
        )}
        <ul className="mt-4 space-y-3">
          {help.points.map((p, i) => (
            <li key={i} className="flex gap-3" data-testid={`help-point-${i}`}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-bold text-primary">{i + 1}</span>
              <span className="text-sm leading-relaxed text-foreground">{p}</span>
            </li>
          ))}
        </ul>
        <p className="mt-6 text-xs text-muted-foreground">
          Suggerimento: trovi la guida completa dei flussi amministrativi in <span className="font-semibold">Amministrazione → Come funziona</span>.
        </p>
      </SheetContent>
    </Sheet>
  );
}
